<main class="region-selection">
  <section class="selection-card" aria-labelledby="region-selection-title">
    <img src="/assets/images/ey-logo-new.png" alt="EY" class="ey-logo" />
    <h1 id="region-selection-title">
      {{ isAccessDenied ? "Access Denied" : "Select your region" }}
    </h1>
    <p *ngIf="!isAccessDenied" class="instructions">
      Select the region you want to access.
    </p>

    <p *ngIf="isLoading" class="status-message" role="status">
      Loading your available regions…
    </p>

    <p *ngIf="errorMessage" class="status-message error-message" role="alert">
      {{ errorMessage }}
    </p>

    <p *ngIf="isRedirecting" class="status-message" role="status">
      Continuing to the selected application…
    </p>

    <div
      *ngIf="shouldShowRegionList && regions.length > 0"
      class="region-list"
      role="radiogroup"
      aria-label="Available regions"
    >
      <label
        *ngFor="let region of regions"
        class="region-option"
        [class.selected]="selectedRegionName === region.regionName"
      >
        <input
          type="radio"
          name="selectedRegion"
          [value]="region.regionName"
          [checked]="selectedRegionName === region.regionName"
          [disabled]="isRedirecting"
          (change)="selectRegion(region)"
        />
        <span>{{ region.regionName }}</span>
      </label>
      <div class="continue-actions">
        <button
          type="button"
          class="continue-button"
          [disabled]="!selectedRegionName || isRedirecting"
          (click)="continueToSelectedRegion()"
        >
          Continue
        </button>
      </div>
    </div>
    <div *ngIf="isAccessDenied" class="access-denied-message">
      <p role="alert">
        User does not have access to this portal. Please reach out to
        <a class="mail-link" href="mailto:info.wamapps@ie.ey.com">info.wamapps@ie.ey.com</a>.
      </p>
      <button
        type="button"
        motifButton
        color="primary-alt"
        size="large"
        (click)="logout()"
      >
        Log out
      </button>
    </div>
  </section>
</main>
